export default class Verification {

    static readonly GOOD: number = 1;
    static readonly SCRAP: number = 2;
    static readonly AWAIT_DISP: number = 3;
    static readonly RETURNED: number = 4;

    desc: string;
    id: number;
    // bootstrap vue only sees value and text in their selectors
    value: number;
    text: string;

    constructor(){
        this.desc = "";
        this.id = 0;
        this.value = 0;
        this.text = "";
    }
}